import firebase from '@/firebase';
import db from '@/db';
import Vue from 'vue';

import { UPDATE_SETTINGS, SET_SETTINGS_ID, SET_SHOULD_REFRESH, SWITCH_IS_SAVING } from './mutations';


const initialState = {
  settings: {
    available_lang: ["fr", "en"],
    brand: {
      brand_name: "Sodexo",
      website_url: {"fr": "https://www.sodexo.fr/", "en": "https://www.sodexo.com/"},
    },
    colors: {
      primary: "#2A295C",
      secondary: "#3CDCC8",
      quiz_progress_bar: "#00f0af", // Quiz card and progress bars
    },
    copy: {
      additionnal_info_get_results_good: {"fr": "Pour accéder à vos résultats détaillés, découvrir les bonnes pratiques associées et bénéficier de nos conseils, merci de bien vouloir remplir ce formulaire.", "en": ""},
      additionnal_info_get_results_bad: {"fr": "Pour accéder à vos résultats détaillés, découvrir les bonnes pratiques associées et bénéficier de nos conseils, merci de bien vouloir remplir ce formulaire.", "en": ""},
      expert_callback_link: {"fr": "", "en": ""},
      expert_callback_text: {"fr": "", "en": ""},
      home_section_1_title: {"fr": "Pour quoi faire ?", "en": "To Do What?"},
      home_section_1_text: {"fr": "", "en": ""},
      home_section_2_title: {"fr": "Comment ça se passe ?", "en": "How Does It Work?"},
      home_section_2_text: {"fr": "", "en": ""},
      home_section_3_title: {"fr": "On y va ?", "en": "Let's go !"},
      home_subtitle: {"fr": "", "en": ""},
      home_title: {"fr": "", "en": ""},
      meta_description: {"fr": "", "en": ""},
      social_icons_share_facebook: {"fr": "", "en": ""},
      social_icons_share_linkedin: {"fr": "", "en": ""},
      social_icons_share_twitter: {"fr": "", "en": ""},
    },
    default_lang: "fr",
    forms: {
      hubspot_form_landing_id: "", // the form on landing page (usually just email)
      hubspot_form_result_id: "", // the form to get the results (usually company, name, ...)
      showing_form_landing: false,
      showing_form_result: false,
    },
    integrations: {
      zapier: {
        enabled: false,
        api_endpoint: ""
      },
      gtm: {
        enabled: false,
        container_id: ""
      },
      google_analytics: {
        enabled: false,
        tracking_id: ""
      },
      hubspot: {
        enabled: false,
        portalID: "",
        api_endpoint: "",
        hutk: ""
      }
    },
    logos: { // ToDo : next version we should rename this 'images'
      header_overlay:"", // Logo on bright backgrounds
      header_title:"", // Logo on dark backgrounds
      main:"", // Logo on landing and result page+print

      landing_image: "", // Landing page image
    },
    internationalization: {
      available_lang: ["fr", "en"],
      default_lang: "fr",
      enabled: false,
    },
    show_question_ordered: true
  },
  isSaving: false,
  should_refresh: false,
  docID: null
};

const state = Object.assign({}, initialState)

const getters = {
  settings: ({settings}) => settings,
  shouldRefresh: ({should_refresh}) => should_refresh,
  isSaving: ({isSaving}) => isSaving,
};

const mutations = {

  [SET_SETTINGS_ID](state, docID) {
    state.docID = docID;
  },

  [SET_SHOULD_REFRESH](state, value) {
    state.should_refresh = value;
  },

  [UPDATE_SETTINGS](state, payload) {
    // We update the settings
    // payload = {"available_lang": ["fr", "en"], "integrations": {...}}
    state.settings = payload;
  },

  [SWITCH_IS_SAVING](state, isSaving) {
    if (typeof isSaving === "undefined") {
      state.isSaving = !state.isSaving;
    } else {
      state.isSaving = isSaving
    }
  },
};

const actions = {

  async getOrCreateSetting({state, commit}, payload ) {

    // payload = {"available_lang": ["fr", "en"], "integrations": {...}}

    // 1 - we first check if the setting already exists locally. If yes, we return
    // 2 - otherwise we check if the setting is already existing on server and fetch existing info
    // and we save into Firebase

    if (state.docID === null) {
      var need_refresh = true;
    } else {
      var need_refresh = false;
    }

    const settings = await db.collection('settings')
                            .limit(1)
                            .get();

    // 1 - create
    if (settings.docs.length == 0 || !settings.docs[0].exists) {
      console.log("Settings don't exist on Firebase yet, we create it");
      // the project has not saved any settings yet, we do it now
      const newDoc = await db.collection('settings').add({
            ...state.settings
          });

      commit(SET_SETTINGS_ID, newDoc.id);
    }
    else
    {
      console.log("We got the settings and intialize them");
      // 2 - the settings exist in DB, we retrieve the data
      // We set all fields we got from the DB and let the other by default
      for(var key in settings.docs[0].data()) {
          if(state.settings.hasOwnProperty(key)) {
            state.settings[key] = settings.docs[0].data()[key];
          }
        }
      commit(SET_SETTINGS_ID, settings.docs[0].id);
    }

    commit(SET_SHOULD_REFRESH, need_refresh); // If the settings have been initialized during this load, we need to refresh the page so that created() methods have access to the settings from back-office.
    // The flog "should_refresh" is then used in App.vue in a :key binding reloading system.


  },

  async saveSettings({state, commit}, payload) {
    // state.isSaving = true;
    commit(SWITCH_IS_SAVING, true)
    commit(UPDATE_SETTINGS, payload);
    // Save the profile in Firestore
    await db.collection('settings').doc(state.docID).update({
            ...state.settings
          });
    // state.isSaving = false;
    commit(SWITCH_IS_SAVING, false)
  },

};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/settings/index.js